import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { Button, Input, PasswordForce } from 'components'
import { STATICS } from 'statics'
import { useForm } from 'hooks'
import {
  MAXIMUM_PASSWORD_LENGTH,
  MESSAGES,
  MINIMUM_PASSWORD_LENGTH,
  NEITHER_WHITESPACE_NOR_COMMA_PATTERN,
} from 'app-constants'
import { PageHeader } from '../page-header'
import { RemindLaterLink } from '../remind-later-link'
import './style.scss'

const validationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required(MESSAGES.REQUIRED)
    .min(MINIMUM_PASSWORD_LENGTH, MESSAGES.PASSWORD_MIN_LENGTH)
    .max(MAXIMUM_PASSWORD_LENGTH, MESSAGES.PASSWORD_MAX_LENGTH)
    .test(
      'newPassword',
      'A senha não pode conter espaços ou vírgulas',
      value => value && NEITHER_WHITESPACE_NOR_COMMA_PATTERN.test(value)
    ),
  confirmationNewPassword: Yup.string()
    .required(MESSAGES.REQUIRED)
    .oneOf([Yup.ref('newPassword'), null], MESSAGES.PASSWORDS_DONT_MATCH),
})

export function PasswordForm({ onContinue }) {
  const [error, setError] = useState(null)
  const form = useForm({
    initialValues: {
      newPassword: '',
      confirmationNewPassword: '',
    },
    validationSchema,
    onSubmit: handleSubmit,
  })

  useEffect(() => {
    const errors = [...Object.values(form.errors)]
    if (errors[0]) {
      setError({ title: errors[0] })
    } else setError(null)
  }, [form.errors])

  function handleSubmit() {
    onContinue(form.values.newPassword)
  }

  function renderRuleStatus(label, isValid) {
    return (
      <li className={`item ${isValid ? '-valid' : ''}`}>
        <STATICS.CHECK_CIRCLE /> {label}
      </li>
    )
  }

  function renderPasswordValidation() {
    const validSize = form.values.newPassword.length >= 6
    const equalPassword =
      validSize && form.values.newPassword === form.values.confirmationNewPassword
    return (
      <div className='password-validation'>
        A senha deve ter
        <ul>
          {renderRuleStatus('No mínimo 6 caracteres', validSize)}
          {renderRuleStatus('As senhas coincidem', equalPassword)}
        </ul>
      </div>
    )
  }

  return (
    <div className='password-form-container'>
      <form className='form' onSubmit={form.handleSubmit}>
        <PageHeader showAlert />
        <h4 className='title'>Digite sua senha</h4>
        <div className='fields'>
          <Input
            className='password'
            name='newPassword'
            label='Nova senha'
            type='password'
            maxLength='20'
            value={form.values.newPassword}
            onChange={form.handleChange}
            hasError={form.errors.newPassword}
          />
          <div className='password-force-container'>
            <PasswordForce password={form.values.newPassword} />
          </div>
          <Input
            className='confirmation'
            name='confirmationNewPassword'
            label='Repetir nova senha'
            type='password'
            maxLength='20'
            value={form.values.confirmationNewPassword}
            onChange={form.handleChange}
            hasError={form.errors.confirmationNewPassword}
          />
          {!!error && <p className='error'>{error.title}</p>}
          {renderPasswordValidation()}
        </div>
        <Button
          className='button'
          type='submit'
          color='primary'
          size='large'
          isLoading={form.isSubmitting}
          disabled={!form.dirty}
        >
          continuar
        </Button>
        <RemindLaterLink label='lembrar mais tarde' />
      </form>
    </div>
  )
}
